// Posisi panel Versi B dijepit di dalam layar: kelompok bawah (Master Data, Pengaturan) naik ke atas alih-alih
// terpotong di bawah; tinggi panel <= tinggi layar dengan gulir di dalam panel (vonis Owner 25 Sep 2026 sore butir 5).
const JARAK_TEPI = 8;

export function posisiPanel(tombol, tinggiPanel, lebarPanel, layar) {
  const maxH = Math.max(120, layar.tinggi - 2 * JARAK_TEPI);
  const h = Math.min(tinggiPanel, maxH);
  const top = Math.max(JARAK_TEPI, Math.min(tombol.top, layar.tinggi - JARAK_TEPI - h));
  const left = Math.max(JARAK_TEPI, Math.min(tombol.right + 4, layar.lebar - JARAK_TEPI - lebarPanel));
  return { top, left, maxHeight: maxH };
}
